import React from "react";

import {Check} from "react-feather";

import * as S from "./styles";
import { IProps } from "./types";

export const OverlayItem: React.FC<IProps> = ({
  children,
  selected,
  testingContextId,
  disabled,
  onClick,
}: IProps) => {
  return (
    <S.Wrapper
      selected={!!selected}
      disabled={!!disabled}
      onClick={onClick}
      data-test="attributeOption"
      data-test-id={testingContextId}
    >
      {children}
      {selected && <Check size={24} color='#fff' strokeWidth={2}/>}
    </S.Wrapper>
  );
};
